import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./Detailing&coating.css";
import NavComplete from "./Component/Navbar1";
import Footer from "./Component/footer";

const DetailingPage = () => {
  const metaData = {
    name: "description",
    content: "Daftar harga dan layanan Detailing kami. Dapatkan hasil terbaik untuk mobil Anda.",
  };

  return (
    <>
      <NavComplete />
      <section className="welcome-section" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', backgroundColor: '#1a1a1a' }}>
        <Container>
          <Row>
            <Col className="container-1">
              <div className="welcome-content" style={{ marginTop: '100px', textAlign: 'left' }}>
                <h1 className="blurry-text" style={{ color: 'white', fontWeight: 'bold' }}>
                  {localStorage.getItem("bahasa") === "ing" ? "Consultation  Services" : "Layanan Konsultasi"}
                </h1>
                <p className="blurry-text" style={{ color: '#ccc', fontSize: '1.2rem', marginTop: '20px' }}>
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Our premium consultation packages designed to bring your car back to life."
                    : "Paket konsultasi premium kami yang didesain untuk membuat mobil Anda tampak seperti baru."}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>



      <Footer />

      <Helmet>
        <meta name={metaData.name} content={metaData.content} />
      </Helmet>
    </>
  );
};

export default DetailingPage;
